import { render, staticRenderFns } from "./cost_and_collection.vue?vue&type=template&id=39a35296&scoped=true&"
import script from "./cost_and_collection.vue?vue&type=script&lang=js&"
export * from "./cost_and_collection.vue?vue&type=script&lang=js&"
import style0 from "./cost_and_collection.vue?vue&type=style&index=0&id=39a35296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a35296",
  null
  
)

export default component.exports